export const displayWhenPrint = (print?: boolean) => {
	return print ? "none" : "flex";
};

export const noOfLines = (print?: boolean) => {
	return print ? undefined : 1;
};
